module.exports = __webpack_public_path__ + "img/apron.2282b674.svg";